import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    height: 104px;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 12px;
    margin-top: 16px;
    cursor: pointer;
  `,
  header: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 12px;
    font-family: 'Montserrat Medium', Arial, Helvetica, sans-serif;
    color: ${colors.slate};
  `,
  title: css`
    max-width: 85%;
    color: ${colors.prussian};
    font-family: 'Montserrat Bold', Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    padding-bottom: 4px;
  `,
  flyer: css`
    width: 78px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border: solid 1px ${colors.mercury};
  `,
  content: css`
    display: flex;
    flex-direction: column;
    padding: 0px 0px 8px 16px;
    width: 100%;
  `,
  criticalDatesContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    /* margin-top: 8px; */
    font-size: 12px;
    color: ${colors.prussian};
    font-family: 'Montserrat Medium', Arial, Helvetica, sans-serif;
  `,
  titleExpired: css`
    color: ${colors.slate};
  `,
  expiredDate: css`
    color: ${colors.stone};
  `,
  activityText: css`
    color: ${colors.slate};
    font-size: 11px;
  `,
};

export default styles;
